export default class ApiException extends Error {
  constructor(public code: ApiErrorCode, public details?: Record<string, unknown>) {
    super(`API Exception [${code}]`);
  }
}

export type ApiErrorCode =
  | 'PARAM.VALIDATION_ERROR'
  | 'DATA.DUPLICATION_ERROR'
  | 'DATA.NOT_EXIST'
  | 'DATA.ALREADY_PROCESSED'
  | 'DATA.FREEID_NOTFOUND'
  | 'DATA.CLASS_NOT_EMPTY'
  | 'DATA.NG_WORD_ERROR'
  | 'DATA.REVIEW_OVER_LIMIT_ERROR'
  | 'DATA.BOOK_MAX_ERROR'
  | 'DATA.BOOK_POSITION_MAX_ERROR'
  | 'DATA.PURCHASE_MAX_ERROR'
  | 'DATA.NOT_ENOUGH_BALANCE_ERROR'
  | 'DATA.REGISTER_RANKING_OVER_LIMIT_ERROR'
  | 'DATA.PUBLISH_RANKING_OVER_LIMIT_ERROR'
  | 'DATA.REGISTER_AND_PUBLISH_RANKING_OVER_LIMIT_ERROR'
  | 'AUTH.INVALID_LOGIN_INFO'
  | 'AUTH.TOO_MANY_LOGIN_ATTEMPTS'
  | 'AUTH.INVALID_SESSION'
  | 'AUTH.AUTO_LOGOUT'
  | 'AUTH.FORCED_LOGOUT'
  | 'AUTH.MISMATCHED_PASSWORD'
  | 'ACCESS.DENIED'
  | 'ACCESS.UNAVAILABLE'
  | 'ACCESS.OUT_OF_LIMIT'
  | 'TARGET.NOT_FOUND'
  | 'SERVER.INTERNAL_ERROR'
  | 'SYSTEM.UNAVAILABLE'
  | 'DATA.CONFLICT'
  | 'AUTH.SSO_LOGIN_ERROR';
